export default class Banner{
    constructor(){
        this.id=null;
        this.title='';
        this.description='';
        this.image=null;
        this.link='';
    }
}